export default "__VITE_ASSET__DDXo8SvP__"